module.exports = __webpack_public_path__ + "../../../static/img/c_im_9.2e22ae56.png";